import React from 'react';

import { List } from '../../components';
import { ListContainer } from '../../containers';
import { useRefreshPage } from '../../hooks/useRefreshPage';

import PurchaseOrderListItem from './PurchaseOrderListItem';

const PurchaseOrderList = ({
	items,
	refetch,
	customProps,
}) => {
	const [refreshPage, isRefreshing] = useRefreshPage(refetch);

	return (
		<List
			items={items}
			listItemComponent={PurchaseOrderListItem}
			onRefresh={refreshPage}
			isRefreshing={isRefreshing}
			emptyListMessage="No purchase orders found"
			autoScrollTop={true}
			showControls={true}
			removeTopMargin={true}
			customProps={customProps}
			assembler={[]}
		/>
	);
};

export default ListContainer(PurchaseOrderList);
